import { reset, SubmissionError } from 'redux-form';
import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';
import { actions as parentActions } from '../../profile';

import _pick from 'lodash/fp/pick';
import _path from 'lodash/fp/path';
import _forEach from 'lodash/fp/forEach';

const defaultInitialState = {
	fields: {
		affiliate_id: null,
		amount: null,
		comment: null,
		conversion_geo: null
	},
	isShow: false,
	disabledFields: []
};

const prepareFormErrors = errors => {
	const validationsErrors = {};
	_forEach(value => {
		const key = value.dataPath.slice(1);
		validationsErrors[key] = value.message;
	}, errors);
	return validationsErrors;
};

const errorReducerFn = (state, action) => {
	if (action.payload.response.status !== 400) {
		return { ...state, error: true, showProgressBar: false };
	}
	return state;
};

const createForm = ({ namespace, stateNodeName, formName }) => {
	const FORM_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-submit-point-transaction-form-success`;
	const FORM_SUBMIT_ERROR = `${namespace}/${stateNodeName}-submit-point-transaction-form-error`;
	const TOGGLE_POINT_FORM = `${namespace}/${stateNodeName}-toggle-point-transaction-form`;

	const initialState = { ...defaultInitialState };

	const actions = {
		pointTransactionFormSubmit: formData => (dispatch, getState) => {
			const data = _pick(['amount', 'comment', 'affiliate_id', 'conversion_geo'])(formData);
			const amount = data.amount && data.amount.replace(/ /g, '');
			const affiliate_id = _path(['affiliate_id', 0, 'value'])(data);
			const conversion_id = _path(['conversion_geo', 0, 'value'])(data);

			const request = http({
				url: endpoints.AFFILIATES.POINTS_TRANSACTION.replace('{id}', affiliate_id),
				method: 'post',
				actions: [FORM_SUBMIT_SUCCESS, FORM_SUBMIT_ERROR],
				data: {
					amount: parseFloat(amount),
					comment: data.comment,
					conversion_id
				}
			});

			return dispatch(request)
				.then(action => {
					if (action.type === FORM_SUBMIT_SUCCESS) {
						dispatch(parentActions.fetchData({ params: { id: affiliate_id }}));
						dispatch(actions.togglePointTransactionForm());
					}
					if (action.type === FORM_SUBMIT_ERROR && action.payload.response.status === 400) {
						const responseErrors = action.payload.response.data;
						throw new SubmissionError(prepareFormErrors(responseErrors));
					}
				});
		},
		togglePointTransactionForm: disabledFields => dispatch => {
			dispatch(reset(formName));
			dispatch({ type: TOGGLE_POINT_FORM, payload: disabledFields });
		}
	};

	const reducers = {
		[TOGGLE_POINT_FORM]: (state, action) => ({
			...state,
			pointTransactionForm: {
				...state.pointTransactionForm,
				isShow: !state.pointTransactionForm.isShow,
				disabledFields: action.payload
					? state.pointTransactionForm.disabledFields.concat(action.payload)
					: state.pointTransactionForm.disabledFields
			}
		}),
		[FORM_SUBMIT_ERROR]: errorReducerFn
	};

	const selectors = {
		getPointFormData: state => {
			const { fields } = _path([namespace, 'pointTransactionForm'])(state);
			return {
				initialValues: {
					...fields
				}
			};
		},
		getShouldShowPointStatus: _path([namespace, 'pointTransactionForm', 'isShow'])
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/points-transaction-form/index.js